import api from './api'
import type { JobConnector, JobResume } from './jobs'
import { findDeploymentHistoryEntry } from './deploymentHistory'

export function createDeploymentHistoryConnector(resume: JobResume): JobConnector {
  return handlers => {
    let cancelled = false
    let timer = 0
    const startedAt = Number(resume.startedAt || 0)
    const siteId = String(resume.siteId || '')
    const expectedKind = String(resume.deploymentKind || '')
    const poll = async () => {
      if (cancelled || !siteId) return
      if (Date.now() > startedAt + 65 * 60 * 1000) {
        handlers.appendLine('Deployment geçmişinde bir saat içinde tamamlanmış kayıt bulunamadı; agent ve site geçmişini kontrol edin.')
        handlers.finish(false)
        return
      }
      try {
        const response = await api.get(`/deployments/${encodeURIComponent(siteId)}/history`)
        const match = findDeploymentHistoryEntry(response.data?.entries, startedAt, expectedKind)
        if (match) {
          String(match.output || 'Deployment tamamlandı; kayıtlı terminal çıktısı yok.').split('\n').filter(Boolean).forEach(handlers.appendLine)
          handlers.finish(match.ok === true)
          return
        }
      } catch {
        // Agent restartı veya kısa ağ kesintisinde kalıcı geçmişi tekrar sorgula.
      }
      if (!cancelled) timer = window.setTimeout(() => void poll(), 2000)
    }
    void poll()
    return () => { cancelled = true; window.clearTimeout(timer) }
  }
}
